import { Links } from '@/application/constants/links';
import { enableInverseCalculation } from '@/application/feature-flags/inverse-calculation';
import { MigrationEmailSentPage } from '@/pages/unauthorized/migration-email-sent/MigrationEmailSentPage';
import { PasswordResetPage } from '@/pages/unauthorized/password-reset/PasswordResetPage';
import { UnauthorizedRootPage } from '@/pages/unauthorized/root-page/UnauthorizedRootPage';
import { createBrowserRouter, Navigate, redirect } from 'react-router';

import { ExportRecipes } from './export-recipes/ExportRecipes';
import { MaterialsPage } from './materials-page/MaterialsPage';
import { PromocodesPage } from './promocodes/PromocodesPage';
import { RecipeCalculationsPage } from './recipe-calculations-page/RecipeCalculationsPage';
import { RecipeInvestigationPage } from './recipe-investigation-page/RecipeInvestigationPage';
import { RecipePage } from './recipe-page/RecipePage';
import { RootPage } from './root-page/RootPage';
import { UserProfilePage } from './user-profile-page/UserProfilePage';
import { WelcomePage } from './welcome-page/WelcomePage';

export const authorizedRoutes = () =>
  createBrowserRouter([
    {
      path: Links.FeatureFlags.EnableInverseCalculation,
      loader: () => {
        enableInverseCalculation();
        return redirect(Links.Authorized.Dashboard);
      },
    },
    // Needed to allow users open reset password page, when they are logged in.
    {
      element: <UnauthorizedRootPage />,
      children: [
        {
          path: Links.Unauthorized.PasswordReset,
          element: <PasswordResetPage />,
        },
        {
          path: Links.Unauthorized.MigrationEmailSent,
          element: <MigrationEmailSentPage />,
        },
      ],
    },
    {
      element: <RootPage />,
      children: [
        {
          path: '*',
          element: <Navigate to={Links.Authorized.Dashboard} />,
        },
        {
          path: Links.Authorized.Dashboard,
          element: <WelcomePage />,
        },
        {
          path: Links.Authorized.Folder,
          element: <WelcomePage />,
        },
        {
          path: Links.Authorized.Recipe,
          element: <RecipePage />,
          children: [
            {
              path: Links.Authorized.RecipeCalculations,
              element: <RecipeCalculationsPage />,
            },
            {
              path: Links.Authorized.RecipeInvestigation,
              element: <RecipeInvestigationPage />,
            },
          ],
        },
        {
          path: Links.Authorized.ExportRecipes,
          element: <ExportRecipes />,
        },
        {
          path: Links.Authorized.MaterialsWithSelection,
          element: <MaterialsPage />,
        },
        {
          path: Links.Authorized.Promocodes,
          element: <PromocodesPage />,
        },
        {
          path: Links.Authorized.UserProfile,
          element: <UserProfilePage />,
        },
      ],
    },
  ]);
